import React from "react";
import { Col } from "react-bootstrap";

const DashboardStatBox = ({ value, label, icon, iconColor, background, xs = 12, sm = 6, md = 4, lg = 3 }) => (
  <Col xs={xs} sm={sm} md={md} lg={lg}>
    <div className="analytics-stat-box text-center p-2 p-md-3 rounded-3 h-100" style={{ background: background ?? "rgba(74, 144, 226, 0.08)" }}>
      {icon && <i className={`bi ${icon} analytics-stat-icon`} style={{ color: iconColor ?? "#4A90E2" }} />}
      <h3 className="fw-bold mt-2 mb-1 analytics-stat-value">{value}</h3>
      <div className="text-muted small">{label}</div>
    </div>
  </Col>
);

export default DashboardStatBox;
